import ru from './messages/ru';
import en from './messages/en';

export * from './const';
export const lang = {
    locale: 'ru',
    fallbackLocale: 'en',
    messages: {
        ru,
        en
    },
    silentTranslationWarn: true
};